import React from 'react';
//material
import {Container, withStyles, Table, TableBody, TableHead, TableRow, TableCell, Button, Card, CardContent} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './meetings-styles';
//utils
import Moment from 'moment';
//components
import PageHeading from '../../../components/page-heading';

let bookingUrl = process.env.REACT_APP_COMPETITIONGOLF_TEMP_BOOKING_URL;
bookingUrl = (!bookingUrl.startsWith('#{') && !bookingUrl.endsWith('}#')) ? bookingUrl : null;

const Meetings = (props) => {
  const {classes, isLoading, meetings} = props;

  return (
    <Container maxWidth={'md'}>
      <PageHeading heading={'Meetings'}/>

      <Card>
        <CardContent>
          {
            !isLoading && meetings.length > 0 &&
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Meeting Date</TableCell>
                    <TableCell>Group</TableCell>
                    <TableCell>Club</TableCell>
                    <TableCell>Attendees</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>

                <TableBody>
                  {
                    meetings.map((meeting, key) =>
                      <TableRow key={key}>
                        <TableCell>{Moment(new Date(meeting.date)).format('ddd Do MMMM YYYY')}</TableCell>
                        <TableCell>{meeting.groupName}</TableCell>
                        <TableCell>{meeting.clubName}</TableCell>
                        <TableCell>{meeting.attendees}</TableCell>
                        <TableCell>
                          {
                            meeting.canBook &&
                            <Button
                              color={'primary'}
                              size={'small'}
                              aria-label={'small'}
                              variant={'contained'}
                              href={bookingUrl}
                              target={'_blank'}
                              rel={'noopener'}>
                              Book
                            </Button>
                          }
                        </TableCell>
                      </TableRow>)
                  }
                </TableBody>
              </Table>
          }

          {
            !isLoading && meetings.length === 0 &&
            <div className={classes.noMeetings}>
              No Meetings to show
            </div>
          }

          {
            isLoading &&
              <>
                <Skeleton variant={'rect'} height={40} className={classes.skeleton}/>
                <Skeleton variant={'rect'} height={30} className={classes.skeleton}/>
                <Skeleton variant={'rect'} height={30} className={classes.skeleton}/>
                <Skeleton variant={'rect'} height={30} className={classes.skeleton}/>
                <Skeleton variant={'rect'} height={30} className={classes.skeleton}/>
                <Skeleton variant={'rect'} height={30} className={classes.skeleton}/>
              </>
          }
        </CardContent>
      </Card>
    </Container>
  );
};

export default withStyles(styles) (Meetings);
